/// <reference path="./index.d.ts" />
import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createStore, Store, compose, applyMiddleware, Middleware } from "redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import rootReducer from "./reducers/rootReducer";
import rootSaga from "./sagas/rootSaga";
import Main from "./containers/Main/Main";
import { Loader } from "semantic-ui-react";
import TagManager from "react-gtm-module";
import "semantic-ui-less/semantic.less";
import "./assets/react-table.css";
import "./index.scss";

// Why is this?
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
  }
}

// Why are these?
const sagaMiddleware: SagaMiddleware<{}> = createSagaMiddleware();
const middleware: Middleware[] = [sagaMiddleware];
const composeEnhancers =
  (process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

/**
 * Store holds the data of the application https://redux.js.org/basics/store
 *
 * rootReducer holds all reducers and reducers are the only way to change the store
 * TODO: Comment what and why is an enhancer and middleware.
 */
const store = createStore(
  rootReducer as any,
  composeEnhancers(applyMiddleware(...middleware))
) as Store<State.Root>;

const persistor = persistStore(store);

/**
 * What does this do and why is it needed?
 */
sagaMiddleware.run(rootSaga);

const tagManagerArgs = { gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS_GTM_ID || "" };

if (tagManagerArgs.gtmId && tagManagerArgs.gtmId !== "GTM-000000") {
  TagManager.initialize(tagManagerArgs);
  console.log("Google analytics enabled");
} else {
  console.log("Google analytics disabled");
}

const RootApp = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<Loader />}>
      <Main />
    </PersistGate>
  </Provider>
);

// React 18 createRoot API
const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
root.render(<RootApp />);